import script from "./FormAttributes.vue?vue&type=script&setup=true&lang=js"
export * from "./FormAttributes.vue?vue&type=script&setup=true&lang=js"

import "./FormAttributes.vue?vue&type=style&index=0&id=16f8e088&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16f8e088"]])

export default __exports__